import ErrorFallback from 'Components/ErrorFallback'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'
import { RefundCodeCreatePage, RefundCodeEditPage, RefundCodeListPage } from './Pages'

function RefundCodeRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<RefundCodeListPage />} />
        <Route path="create" element={<RefundCodeCreatePage />} />
        <Route path=":id/edit" element={<RefundCodeEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}

export default RefundCodeRoot
